import { useQuery } from '@tanstack/react-query'
import api from 'lib/interceptor/axios.interceptor'
import type { Feature } from 'lib/providers/feature.provider'

const getApplicationFeatures = async () => {
	const response = await api.get('/api/applicationfeatures')
	return response.data as Feature[]
}

// eslint-disable-next-line import/prefer-default-export
export const useLoadApplicationFeatures = (emailId: string, enabled = true) =>
	useQuery({
		queryKey: ['applicationfeatures', emailId],
		queryFn: async () => getApplicationFeatures(),
		enabled
	})
